<main class="p-4 p-xxl-5 risk-review-page">
  <section v-if="is_risk_detail_page" class="risk-review-workspace">
    <div v-if="!selected_risk" class="risk-review-shell p-5 text-center text-muted">
      Loading risk review case...
    </div>

    <div v-else class="risk-review-shell">
      <div v-if="risk_journey_steps.length" class="card border rounded-3 mb-4">
        <div class="card-body py-3">
          <div class="workflow-stepper">
            <div
              v-for="(step, index) in risk_journey_steps"
              :key="`${step.gate_id}-${index}`"
              class="workflow-stepper__item"
            >
              <button
                type="button"
                class="btn border-0 bg-transparent p-0 text-center workflow-stepper__trigger"
                :disabled="step.state !== 'completed' || !step.can_navigate"
                @click="open_gate_journey_step(step)"
              >
                <div class="workflow-stepper__content">
                  <span
                    :class="[
                      'rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0',
                      'workflow-step-circle',
                      step.state === 'completed' ? 'bg-success text-white' : step.state === 'current' ? 'border border-success text-success bg-white' : 'bg-light text-muted'
                    ]"
                  >
                    <i v-if="step.state === 'completed'" class="bi bi-check-lg" aria-hidden="true"></i>
                    <span v-else>{{ index + 1 }}</span>
                  </span>
                  <span :class="['workflow-stepper__label fw-semibold', step.state === 'upcoming' ? 'text-muted' : 'text-black']">{{ step.label }}</span>
                  <span class="workflow-stepper__meta small text-muted">{{ step.state === 'completed' ? 'Completed' : step.state === 'current' ? 'Current' : 'Upcoming' }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="risk-review-hero"
        tabindex="0"
        @click="open_risk_page_drawer"
        @keyup.enter="open_risk_page_drawer"
      >
        <div class="risk-review-hero__main">
          <span class="risk-review-hero__avatar rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
            {{ selected_risk.case_name?.charAt(0) || 'R' }}
          </span>
          <div class="min-w-0">
            <div class="risk-review-hero__eyebrow">Applicant risk review</div>
            <div class="risk-review-hero__name text-truncate">{{ selected_risk.case_name }}</div>
            <div class="risk-review-hero__meta">{{ selected_risk.journey }} applicant - {{ risk_summary_value('Assessment', risk_assessment_name || 'Risk assessment') }}</div>
          </div>
        </div>
        <div class="risk-review-hero__actions">
          <span class="risk-review-score-pill">
            <i class="bi bi-speedometer2" aria-hidden="true"></i>
            {{ applicant_risk_score_value() }} points
          </span>
          <span :class="['badge rounded-pill fw-normal', risk_badge_class(selected_risk.risk_tone)]">
            {{ risk_summary_value('Risk level', selected_risk.risk) }}
          </span>
        </div>
      </div>

      <div class="onboarding-gate-audit-layout mb-4">
        <aside class="onboarding-gate-audit-sidebar">
          <section class="onboarding-gate-current-card-wrap" aria-label="Pinned action">
            <div class="text-uppercase text-muted fw-semibold small">Pinned</div>
            <button
              v-if="current_detail_action_tab()"
              type="button"
              :class="['onboarding-gate-current-card', { 'is-active': active_detail_tab === current_detail_action_tab().id }]"
              @click="set_detail_tab(current_detail_action_tab().id)"
            >
              <span class="onboarding-gate-current-card__icon" aria-hidden="true"></span>
              <span class="onboarding-gate-current-card__body">
                <span class="onboarding-gate-current-card__title">Required Action</span>
                <span class="onboarding-gate-current-card__copy">{{ current_detail_action_copy() }}</span>
              </span>
              <span class="onboarding-gate-current-card__count">1</span>
            </button>
          </section>

          <button
            v-for="tab in detail_tabs_with_history.filter((item) => item.id !== current_detail_action_tab()?.id && /application reference/i.test(item.label || ''))"
            :key="`reference-${tab.id}`"
            type="button"
            :class="['onboarding-gate-audit-reference', { 'is-active': active_detail_tab === tab.id }]"
            @click="set_detail_tab(tab.id)"
          >
            <span class="onboarding-gate-audit-reference__label">{{ tab.label }}</span>
            <span class="onboarding-gate-audit-reference__value">Open application details</span>
          </button>

          <section class="onboarding-gate-audit-panel" aria-label="Case history">
            <div class="onboarding-gate-audit-panel__eyebrow">Onboarding History</div>
            <div class="onboarding-gate-audit-list">
              <button
                v-for="(tab, index) in detail_tabs_with_history.filter((item) => item.id !== current_detail_action_tab()?.id && !/application reference/i.test(item.label || '') && item.id !== 'history')"
                :key="tab.id"
                type="button"
                :class="['onboarding-gate-audit-item', { 'is-active': active_detail_tab === tab.id, 'is-completed': String(tab.badge || '').trim().toLowerCase() === 'completed', 'is-current': String(tab.badge || '').trim().toLowerCase() === 'current' }]"
                @click="set_detail_tab(tab.id)"
              >
                <span class="onboarding-gate-audit-item__marker" aria-hidden="true">
                  <i v-if="String(tab.badge || '').trim().toLowerCase() === 'completed'" class="bi bi-check-lg"></i>
                  <span v-else>{{ index + 1 }}</span>
                </span>
                <span class="onboarding-gate-audit-item__content">
                  <span class="onboarding-gate-audit-item__title">{{ tab.label }}</span>
                  <span v-if="tab.badge" :class="['onboarding-gate-audit-item__status', { 'is-current': String(tab.badge || '').trim().toLowerCase() === 'current' }]">
                    {{ tab.badge }}
                  </span>
                  <span class="onboarding-gate-audit-item__detail">Review this gate section.</span>
                </span>
              </button>
            </div>
          </section>
        </aside>

        <div :class="['onboarding-gate-audit-content risk-review-content', { 'onboarding-gate-audit-content--history': active_detail_shell_tab === 'history' }]">
        <nav class="risk-review-tabs mb-4" aria-label="Risk workspace sections">
          <button
            v-for="tab in detail_shell_tabs"
            :key="tab.id"
            type="button"
            :class="['risk-review-tabs__tab', { 'is-active': active_detail_shell_tab === tab.id }]"
            @click="set_detail_shell_tab(tab.id)"
          >
            <span>{{ tab.label }}</span>
            <span v-if="tab.badge" class="badge rounded-pill">{{ tab.badge }}</span>
          </button>
        </nav>

        <section v-if="active_detail_tab === 'risk'" class="risk-review-layout">
          <aside
            class="risk-review-panel risk-review-panel--tinted cursor-pointer"
            tabindex="0"
            @click="open_risk_page_drawer"
            @keyup.enter="open_risk_page_drawer"
          >
            <h2 class="risk-review-section-title">Applicant Weight Score</h2>
            <p class="risk-review-section-copy">This compares the applicant's selected answer weights against the configured maximum weight for this assessment.</p>
            <div class="risk-review-score-card mt-4">
              <div class="risk-review-score-card__value">
                {{ applicant_risk_score_value() }}
                <span>/ {{ total_possible_risk_weight() || '-' }}</span>
              </div>
              <div class="risk-review-score-card__label">Applicant weighted score</div>
              <div class="risk-review-score-card__bar" aria-hidden="true">
                <span :style="{ width: `${applicant_risk_score_percent()}%` }"></span>
              </div>
              <div class="risk-review-score-card__percent">{{ applicant_risk_score_percent() }}% of possible risk weight</div>
            </div>
            <div class="risk-review-stat-grid mt-4">
              <div class="risk-review-stat">
                <div class="risk-review-stat__label">Risk level</div>
                <div class="risk-review-stat__value">{{ risk_summary_value('Risk level', selected_risk.risk) }}</div>
              </div>
              <div class="risk-review-stat">
                <div class="risk-review-stat__label">Auto decision</div>
                <div class="risk-review-stat__value">{{ risk_summary_value('Auto decision') }}</div>
              </div>
              <div class="risk-review-stat">
                <div class="risk-review-stat__label">Recommended action</div>
                <div class="risk-review-stat__value">{{ risk_summary_value('Reviewer action', selected_risk.action) }}</div>
              </div>
            </div>
            <div class="risk-review-decision mt-4">
              <div class="fw-bold text-black mb-1">Admin decision guide</div>
              <p class="mb-0">{{ risk_review_guidance }}</p>
            </div>
          </aside>

          <div
            class="risk-review-panel cursor-pointer"
            tabindex="0"
            @click="open_risk_page_drawer"
            @keyup.enter="open_risk_page_drawer"
          >
            <div class="d-flex align-items-center justify-content-between gap-3 mb-4">
              <div>
                <h2 class="risk-review-section-title">Applicant Risk Evidence</h2>
                <p class="risk-review-section-copy">Each applicant answer is compared with all configured weights for that question.</p>
              </div>
              <span class="badge rounded-pill bg-light text-dark border">{{ risk_factor_items.length }} items</span>
            </div>
            <div v-if="risk_factor_items.length" class="risk-review-answer-list">
              <article
                v-for="factor in risk_factor_items"
                :key="factor.id"
                class="risk-review-answer-card"
              >
                <div class="risk-review-answer-card__top">
                  <div class="min-w-0">
                    <div class="risk-review-answer-card__title">{{ factor.label }}</div>
                    <div class="risk-review-answer-card__answer">Applicant answer: {{ factor.selected_answer || factor.detail }}</div>
                    <div class="risk-review-answer-card__comparison">
                      <span>{{ factor.selected_score || 0 }} selected</span>
                      <span>{{ factor.max_score || 0 }} max</span>
                    </div>
                    <div class="risk-review-answer-card__bar" aria-hidden="true">
                      <span :style="{ width: `${factor.comparison_percent || 0}%` }"></span>
                    </div>
                    <div v-if="factor.choices.length" class="risk-review-weight-options">
                      <span
                        v-for="choice in factor.choices"
                        :key="`${factor.id}-${choice.option}`"
                        :class="['risk-review-weight-option', { 'is-selected': choice.is_selected }]"
                      >
                        {{ choice.option }}: {{ choice.weight }}
                      </span>
                    </div>
                  </div>
                  <span class="risk-review-answer-card__score">{{ factor.selected_score || 0 }}/{{ factor.max_score || 0 }}</span>
                </div>
              </article>
            </div>
            <div v-else class="text-muted">No submitted risk answers were returned for this assessment.</div>
          </div>
        </section>

        <section v-if="active_detail_shell_tab === 'history'" class="risk-review-panel onboarding-history-rail-section">
          <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap mb-4">
            <div>
              <h2 class="risk-review-section-title">Onboarding History</h2>
              <p class="text-muted mb-0 mt-2">Previous gates completed for this case.</p>
            </div>
          </div>

          <div v-if="detail_history_tabs.length" class="onboarding-gate-audit-list">
            <button
              v-for="tab in detail_history_tabs"
              :key="tab.id"
              type="button"
              :class="['onboarding-gate-audit-item', { 'is-active': active_detail_tab === tab.id, 'is-completed': true }]"
              @click="set_detail_tab(tab.id)"
            >
              <span class="onboarding-gate-audit-item__marker" aria-hidden="true">
                <i class="bi bi-check-lg"></i>
              </span>
              <span class="onboarding-gate-audit-item__content">
                <span class="onboarding-gate-audit-item__title">{{ tab.label }}</span>
                <span class="onboarding-gate-audit-item__status">{{ tab.badge }}</span>
                <span class="onboarding-gate-audit-item__detail">Review this completed gate.</span>
              </span>
            </button>
          </div>
          <div v-else class="text-muted">No previous gates have been completed for this case yet.</div>
        </section>

        <section v-if="active_detail_shell_tab === 'history' && !active_historical_gate_tab" class="risk-review-panel onboarding-history-detail-placeholder">
          <div class="text-muted">Select a completed gate to view its details.</div>
        </section>

        <section v-else-if="active_historical_gate_tab" class="risk-review-panel">
          <ManualVerificationHistoryView
            v-if="active_historical_gate_tab.gate_id === 'manual-verification'"
            :decision-action="historical_manual_decision_action()"
            :decision-comment="historical_manual_comment()"
            :decision-label="historical_manual_decision_label()"
            :decision-tone="historical_manual_decision_tone()"
            :status-label="historical_manual_status_label()"
            :review-sections="historical_manual_review_sections()"
            :applicant-form-sections="case_form_sections"
            :documents="selected_risk?.documents || []"
          />
            <div
              v-else-if="active_historical_gate_tab.gate_id === 'verification'"
              class="d-grid gap-3"
            >
              <HistoricalVerificationChecksView
                :checks="active_historical_gate_checks()"
                empty-message="No verification runs were returned for this completed gate."
                :is-expanded="historical_verification_check_expanded"
                :get-check-passed-chips="get_check_passed_chips"
                :get-check-result-detail-rows="get_check_result_detail_rows"
                :get-check-history="get_check_history"
                :status-badge-class="status_badge_class"
                :evidence-icon-class="evidence_icon_class"
                :field-result-row-class="field_result_row_class"
                @toggle-check="toggle_historical_verification_check_expanded"
              />
            </div>
            <div v-else>
            <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap mb-4">
              <div>
                <h2 class="risk-review-section-title">{{ active_historical_gate_tab.label }}</h2>
                <p class="risk-review-section-copy">{{ historical_gate_summary_text() }}</p>
              </div>
            <span :class="['badge rounded-pill fw-normal', risk_badge_class(historical_gate_status_tone())]">
              {{ historical_gate_status_label() }}
            </span>
          </div>

            <div class="row g-3 mb-4">
              <div class="col-md-6 col-xl-3">
                <div class="border rounded-3 px-3 py-2 bg-light h-100">
                  <div class="text-uppercase text-muted fw-semibold small mb-2">Action</div>
                  <div class="fw-semibold text-black">{{ historical_gate_action_label() }}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-3">
                <div class="border rounded-3 px-3 py-2 bg-light h-100">
                  <div class="text-uppercase text-muted fw-semibold small mb-2">Actioned by</div>
                  <div class="fw-semibold text-black">{{ historical_gate_actor() }}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-3">
                <div class="border rounded-3 px-3 py-2 bg-light h-100">
                  <div class="text-uppercase text-muted fw-semibold small mb-2">Completed</div>
                  <div class="fw-semibold text-black">{{ historical_gate_completed_at() }}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-3">
                <div class="border rounded-3 px-3 py-2 bg-light h-100">
                  <div class="text-uppercase text-muted fw-semibold small mb-2">Status</div>
                  <div class="fw-semibold text-black">{{ historical_gate_status_label() }}</div>
                </div>
              </div>
            </div>

            <div class="border rounded-3 px-3 py-3 bg-light mb-4">
              <div class="text-uppercase text-muted fw-semibold small mb-2">Reason</div>
              <div class="text-black">{{ historical_gate_reason() }}</div>
            </div>

          <div v-if="active_historical_gate_checks().length" class="d-grid gap-3">
            <article
              v-for="check in active_historical_gate_checks()"
              :key="check.id"
              class="border rounded-3 px-3 py-3 bg-white"
            >
              <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                <div>
                  <div class="fw-semibold text-black">{{ check.check }}</div>
                  <div class="small text-muted mt-1">{{ check.source || check.impact || 'Completed gate detail' }}</div>
                  <div class="small text-muted">Last run: {{ check.last_run }}</div>
                </div>
                <span :class="['badge rounded-pill fw-normal', risk_badge_class(check.status_tone)]">
                  {{ check.status }}
                </span>
              </div>
              </article>
            </div>
          <div v-else class="text-muted">No reviewable data was returned for this completed gate.</div>
          </div>
        </section>

        <section v-else-if="active_detail_tab === 'application'">
          <ApplicationDetailsReview :form_sections="case_form_sections" />
        </section>

        <section v-else-if="active_detail_tab === 'history'" class="risk-review-panel">
          <div class="d-flex align-items-center justify-content-between gap-3 mb-4">
            <div>
              <h2 class="risk-review-section-title">Risk Assessment History</h2>
              <p class="risk-review-section-copy">Every stored risk evaluation for this application, newest first.</p>
            </div>
            <span class="badge rounded-pill bg-light text-dark border">{{ risk_history_items.length }} runs</span>
          </div>

          <div v-if="risk_history_loading" class="text-muted">Loading risk history...</div>
          <div v-else-if="risk_history_error" class="alert alert-warning mb-0 py-2 px-3 small">{{ risk_history_error }}</div>
          <div v-else-if="risk_history_items.length" class="risk-review-history-list">
            <article
              v-for="item in risk_history_items"
              :key="item.id"
              class="risk-review-history-item"
            >
              <div class="risk-review-history-item__main">
                <div class="risk-review-history-item__title">{{ item.assessment_name || 'Risk assessment' }}</div>
                <div class="risk-review-history-item__meta">
                  <span>{{ format_risk_history_date(item.evaluated_at) }}</span>
                  <span>{{ risk_history_scope_label(item) }}</span>
                  <span>{{ item.triggered_by_kind || 'manual' }}</span>
                </div>
              </div>
              <div class="risk-review-history-item__stats">
                <span class="risk-review-history-score">{{ item.total_score }} points</span>
                <span :class="['badge rounded-pill fw-normal', risk_history_badge_class(item.risk_level)]">
                  {{ item.risk_level || 'Unscored' }}
                </span>
                <span class="risk-review-history-decision">{{ item.auto_decision || '-' }}</span>
                <span v-if="item.config_version_at_run" class="risk-review-history-version">
                  v{{ item.config_version_at_run }}
                </span>
              </div>
            </article>
          </div>
          <div v-else class="text-muted">No risk assessment history has been recorded for this application yet.</div>
        </section>
        </div>
      </div>

      <div v-if="workflow_actions_loading || workflow_actions_error || workflow_action_feedback" class="px-4 pb-4">
        <div v-if="workflow_actions_loading" class="small text-muted">Loading workflow actions...</div>
        <div v-else-if="workflow_actions_error" class="alert alert-warning mb-0 py-2 px-3 small">{{ workflow_actions_error }}</div>
        <div
          v-else-if="workflow_action_feedback"
          :class="['alert mb-0 py-2 px-3 small', workflow_action_feedback_tone === 'success' ? 'alert-success' : workflow_action_feedback_tone === 'danger' ? 'alert-danger' : 'alert-warning']"
        >
          {{ workflow_action_feedback }}
        </div>
      </div>
    </div>
  </section>

  <section v-else class="card border rounded-3 overflow-hidden">
    <div class="card-header bg-white d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
      <div class="d-inline-flex align-items-center flex-wrap border rounded-2 bg-light p-1" role="group" aria-label="Risk filters">
        <button
          v-for="filter in filters"
          :key="filter.label"
          type="button"
          @click="set_active_filter(filter.tone)"
          :class="[
            'btn btn-sm d-inline-flex align-items-center gap-2 px-3 py-1',
            active_filter === filter.tone ? 'bg-white border shadow-sm fw-semibold' : 'border-0 bg-transparent'
          ]"
        >
          <span>{{ filter.label }}</span>
          <span v-if="filter.count">{{ filter.count }}</span>
        </button>
      </div>

      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2">
        <label class="onboarding-queue-search d-inline-flex align-items-center">
          <i class="bi bi-search" aria-hidden="true"></i>
          <input v-model="table_search" type="search" placeholder="Search table" @input="reset_table_page">
        </label>
        <button type="button" class="btn btn-sm bg-white border rounded-2 d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1">
          <i class="bi bi-funnel"></i>
          <span>Filters</span>
        </button>
        <button type="button" class="btn btn-sm bg-white border rounded-2 d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1">
          <i class="bi bi-download"></i>
          <span>Export</span>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th class="text-uppercase text-muted small fw-semibold py-3 ps-4">Onboarded Entity</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Journey</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Risk</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Stage</th>
            <th class="text-uppercase text-muted small fw-semibold py-3 pe-4">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
              v-for="item in paginated_risks"
            :key="`${item.case_name}-${item.score}`"
            class="cursor-pointer"
            tabindex="0"
            @click="open_risk_detail(item)"
            @keyup.enter="open_risk_detail(item)"
          >
            <td class="ps-4 fw-bold text-black py-3">{{ item.case_name }}</td>
            <td class="py-3">{{ item.journey }}</td>
            <td class="py-3">
              <span :class="['badge rounded-pill fw-normal', risk_badge_class(item.risk_tone)]">
                {{ item.risk }}
              </span>
            </td>
            <td class="py-3">{{ item.stage }}</td>
            <td class="pe-4 py-3">
              <button
                type="button"
                class="onboarding-queue-view-button"
                @click.stop="open_risk_page(item)"
              >
                <span>View</span>
                <i class="bi bi-arrow-right-short" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <TablePagination
      :page="table_page"
      :page-size="table_page_size"
      :page-size-options="table_page_size_options"
      :total-rows="table_total_rows"
      :page-start="table_page_start"
      :page-end="table_page_end"
      :total-pages="table_total_pages"
      @update:page="set_table_page"
      @update:page-size="set_table_page_size"
    />
  </section>

  <div
    v-if="should_show_detail_drawer"
    class="onboarding-case-detail-backdrop"
    @click="close_risk_drawer"
  ></div>

  <aside
    v-if="should_show_detail_drawer"
    :class="['onboarding-case-detail-drawer bg-white shadow-lg', { 'is-fullscreen': is_detail_fullscreen }]"
  >
    <header class="border-bottom p-4">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="text-uppercase text-muted fw-semibold small mb-3">
            {{ selected_case_context() }}
          </div>
          <h2 class="h5 fw-bold text-black mb-2">{{ selected_risk.case_name }}</h2>
          <p class="mb-0 text-muted">{{ selected_case_subtitle() }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 flex-shrink-0">
          <span :class="['badge rounded-pill fw-normal', activation_badge_class()]">
            <span class="me-1">&bull;</span>{{ selected_risk.case_item.activation || selected_risk.action }}
          </span>
          <button
            type="button"
            class="btn btn-link text-muted p-0"
            :aria-label="is_detail_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
            :title="is_detail_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
            @click="toggle_detail_fullscreen"
          >
            <i :class="['bi', is_detail_fullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen', 'fs-5']"></i>
          </button>
          <button type="button" class="btn btn-link text-muted p-0" aria-label="Close risk detail" @click="close_risk_drawer">
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>
      </div>
    </header>

    <div class="onboarding-case-detail-body p-4">
      <nav class="bg-light rounded-3 p-1 d-flex align-items-center gap-2 mb-4 onboarding-detail-tabs" aria-label="Risk case detail sections">
        <button
          v-for="tab in drawer_detail_tabs"
          :key="tab.id"
          type="button"
          :class="[
            'btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 onboarding-detail-tabs__button',
            drawer_active_detail_tab === tab.id ? 'bg-white border shadow-sm fw-semibold' : 'border-0 bg-transparent'
          ]"
          @click="set_drawer_detail_tab(tab.id)"
        >
          <i :class="['bi', tab.icon]"></i>
          <span>{{ tab.label }}</span>
        </button>
      </nav>

      <section v-if="drawer_active_detail_tab === 'summary'">
        <dl class="row g-0 mb-4">
          <template v-for="row in summary_rows" :key="row.label">
            <dt class="col-4 text-muted fw-normal mb-3">{{ row.label }}</dt>
            <dd class="col-8 fw-semibold mb-3">{{ row.value || '-' }}</dd>
          </template>
        </dl>

        <section class="mb-4">
          <div class="text-uppercase text-muted fw-semibold small mb-3">Overall readiness</div>
          <div class="d-flex align-items-center gap-3">
            <div class="progress flex-grow-1 onboarding-progress-track">
              <div class="progress-bar onboarding-progress-bar" :style="{ '--onboarding-progress-size': `${selected_risk.case_item.progress || 0}%` }"></div>
            </div>
            <span class="small fw-bold">{{ selected_risk.case_item.progress || 0 }}%</span>
          </div>
        </section>

        <section>
          <div class="text-uppercase text-muted fw-semibold small mb-3">Stage timeline</div>
          <div class="onboarding-case-timeline">
            <article
              v-for="item in stage_timeline"
              :key="item.title"
              :class="['onboarding-case-timeline-item', `is-${item.status}`]"
            >
              <span class="onboarding-case-timeline-icon">
                <i :class="['bi', item.icon]"></i>
              </span>
              <div>
                <div class="fw-semibold text-black">{{ item.title }}</div>
                <div class="text-muted small mt-1">{{ item.detail }}</div>
              </div>
            </article>
          </div>
        </section>
      </section>

      <section v-else-if="active_drawer_form_section">
        <div class="text-uppercase text-muted fw-semibold small mb-3">{{ active_drawer_form_section.label }}</div>
        <section
          v-for="sub_section in active_drawer_form_section.sub_sections"
          :key="sub_section.id"
          class="mb-4"
        >
          <div
            v-if="sub_section.label && sub_section.label !== active_drawer_form_section.label"
            class="text-uppercase text-muted fw-semibold small mb-3"
          >
            {{ sub_section.label }}
          </div>
          <div class="onboarding-answer-grid">
            <article
              v-for="question in sub_section.questions"
              :key="question.id"
              class="onboarding-answer-card"
            >
              <p class="onboarding-answer-card__label">
                {{ question.label }}
                <span v-if="question.is_mandatory" class="text-danger">*</span>
              </p>
              <div class="onboarding-answer-card__value">{{ question.answer }}</div>
            </article>
          </div>
        </section>
      </section>
    </div>

    <footer class="onboarding-case-detail-footer border-top bg-white p-3 d-flex align-items-center justify-content-between gap-3">
      <button type="button" class="btn btn-link text-muted d-inline-flex align-items-center gap-2 text-decoration-none">
        <i class="bi bi-stars"></i>
        <span>Ask AI</span>
      </button>
      <div class="d-flex align-items-center gap-2">
          <button
          type="button"
          class="btn btn-outline-danger d-inline-flex align-items-center gap-2"
          :disabled="!can_reject_stage || workflow_action_in_progress === 'reject' || workflow_actions_loading"
          @click="run_selected_workflow_action('reject')"
        >
          <i class="bi bi-x-circle"></i>
          <span>{{ workflow_action_in_progress === 'reject' ? 'Rejecting...' : 'Reject' }}</span>
        </button>
        <button
          type="button"
          class="btn btn-outline-warning d-inline-flex align-items-center gap-2"
          :disabled="!can_request_info || workflow_action_in_progress === 'request_info' || workflow_actions_loading"
          @click="run_selected_workflow_action('request_info')"
        >
          <i class="bi bi-send"></i>
          <span>{{ workflow_action_in_progress === 'request_info' ? 'Sending...' : 'Request info' }}</span>
        </button>
        <button
          v-if="should_show_risk_advance_stage"
          type="button"
          class="btn btn-primary d-inline-flex align-items-center gap-2"
          :disabled="workflow_action_in_progress === 'advance' || workflow_actions_loading"
          @click="run_risk_advance_stage"
        >
          <i class="bi bi-arrow-right"></i>
          <span>{{ workflow_action_in_progress === 'advance' ? 'Advancing...' : 'Advance stage' }}</span>
        </button>
      </div>
    </footer>
    <div v-if="workflow_actions_loading || workflow_actions_error || workflow_action_feedback" class="px-3 pb-3">
      <div v-if="workflow_actions_loading" class="small text-muted">Loading workflow actions...</div>
      <div v-else-if="workflow_actions_error" class="alert alert-warning mb-0 py-2 px-3 small">{{ workflow_actions_error }}</div>
      <div
        v-else-if="workflow_action_feedback"
        :class="['alert mb-0 py-2 px-3 small', workflow_action_feedback_tone === 'success' ? 'alert-success' : workflow_action_feedback_tone === 'danger' ? 'alert-danger' : 'alert-warning']"
      >
        {{ workflow_action_feedback }}
      </div>
    </div>
  </aside>
</main>
